import setFieldValue from "@iewcasia/Store/Handlers/InstantRegistrationForm/SetFieldValue";
import { CustomActions, CustomState } from "@iewcasia/Store/Reducers";
import { OwnProps, setRequestFormEffects, validateFieldBy } from "@iewcasia/Widgets/CreateAccount/FormBaseComponent";
import translate from "@insite/client-framework/Translate";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import debounce from "lodash/debounce";
import * as React from "react";
import { useEffect, useState } from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";

const mapStateToProps = (state: CustomState) => {
    return {
        dontKnowAccountLink: state.customInstantRegistrationForm.fieldValues.dontKnowAccountLink,
    };
};

type Props = OwnProps & ThemeProps<BaseTheme> & ReturnType<typeof mapStateToProps> & DispatchProp<CustomActions>;

export interface AccountLinkStyles {
    accountLinkHidden?: InjectableCss;
    accountLink?: LinkPresentationProps;
}

export const accountLinkStyles: AccountLinkStyles = {
    accountLinkHidden: {
        css: css`
            line-height: 26px;
        `,
    },
    accountLink: {
        css: css`
            margin-top: 15px;

            @media (max-width: 767px) {
                margin-top: 0;
            }
        `,
    },
};

const InstantAccountLinkWidget: React.FC<Props> = ({ dontKnowAccountLink, theme: { breakpoints } }) => {
    const label = translate("Don't know your account number?");
    const styles = accountLinkStyles;
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleWindowSize = () => {
            const maxMobileIdx = breakpoints.keys.indexOf("md");
            const maxMobile = breakpoints.values[maxMobileIdx];
            setIsMobile(window.innerWidth < maxMobile);
        };
        handleWindowSize();
        const debouncedHandleWindowSize = debounce(handleWindowSize, 200);
        window.addEventListener("resize", debouncedHandleWindowSize);
        // Cleanup event listeners on unmount
        return () => {
            window.removeEventListener("resize", debouncedHandleWindowSize);
        };
    }, []);

    return (
        <>            
            {!isMobile && (
                <Typography {...styles.accountLinkHidden} as="label" data-test-selector="hidden-label">
                    &nbsp;
                </Typography>
            )}
            <Link target="_blank" href={dontKnowAccountLink} rel="noreferrer" {...styles.accountLink}>
                {label}
            </Link>
        </>
    );
};

export default connect(mapStateToProps)(withTheme(InstantAccountLinkWidget));
